import graphql__92f159152c569cc7fd78 from "./__generated__/ContactCustomersPanel_contact.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useFragment} from "react-relay/hooks";
import {Link} from "react-router";
import Panel from "./presentational/Panel";
import {useIntl} from "react-intl";
import Avatar from "./presentational/Avatar";

type Props = {
    queryRef: any;
}

const ContactCustomersPanel: React.FC<Props> = (props) => {
    const intl = useIntl();

    const contact = useFragment(
        graphql__92f159152c569cc7fd78,
        props.queryRef
    );

    const edges = contact.customerAccounts?.edges || [];
    const locale = intl.locale as 'de' | 'en';

    return (
        <Panel headline={intl.formatMessage({id: 'contact.customers'})}>
            {edges.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                    {intl.formatMessage({id: 'contact.customers.noCustomers'})}
                </div>
            ) : (
                <ul className="-mx-4">
                    {edges.map((edge) => {
                        if (!edge?.node) return null;
                        const customer = edge.node;
                        const roles = edge.roles || [];

                        return (
                            <li key={customer.id}>
                                <Link
                                    to={`/customers/${customer.id}`}
                                    className="flex items-center py-3 px-4 cursor-pointer hover:bg-gray-50"
                                >
                                    <Avatar
                                        name={customer.customerName || '?'}
                                        size="sm"
                                    />
                                    <div className="ml-3 flex-1 min-w-0">
                                        <p className="text-sm font-medium text-gray-900 truncate">
                                            {customer.customerName}
                                        </p>
                                        {roles.length > 0 && (
                                            <div className="mt-1">
                                                {roles.map((role, index) => (
                                                    <span
                                                        key={index}
                                                        className="inline-flex items-center mr-1 px-2 py-0.5 rounded-sm text-xs font-medium bg-gray-800/10 text-gray-800"
                                                    >
                                                        {role.label[locale] || role.label.en}
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            )}
        </Panel>
    );
};

export default ContactCustomersPanel;
